import { checkHasVhBug, fixVhBug } from '@nrk/dh-vh'

if (checkHasVhBug()) {
  fixVhBug()
}
